import React from 'react';

function Icon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_78_133)">
        <path d="M12 0.5C14.5068 0.5 17.0137 0.630921 19.5205 0.892764C22.0658 1.15928 23.999 3.30459 24 5.86377V15.1362C23.999 17.6954 22.0658 19.8407 19.5205 20.1072C17.0137 20.3691 14.5068 20.5 12 20.5C9.49316 20.5 6.98633 20.3691 4.47949 20.1072C1.93423 19.8407 0.000993624 17.6954 0 15.1362V5.86377C0.000993624 3.30459 1.93423 1.15928 4.47949 0.892764C6.98633 0.630921 9.49316 0.5 12 0.5ZM8.27736 7.52052C8.17212 7.48212 8.05671 7.48208 7.95144 7.52039L7.66716 7.62386C7.62516 7.63915 7.5871 7.66361 7.55575 7.69546C7.43929 7.81377 7.4408 8.00409 7.55911 8.12054L10.3761 10.8935L8.586 11.5451L5.44516 9.59357C5.38312 9.55504 5.30683 9.54713 5.23821 9.57211L4.31009 9.90991C4.2825 9.91996 4.25701 9.93502 4.2349 9.95434C4.13592 10.0408 4.1258 10.1912 4.21228 10.2901L6.09957 12.4501L5.24479 12.7622C5.11505 12.8095 5.04815 12.9529 5.09538 13.0827C5.14874 13.2293 5.27234 13.3392 5.42419 13.3751L7.39746 13.841C8.84356 14.1826 10.358 14.0937 11.7542 13.5855L19.2968 10.8403C19.511 10.7623 19.687 10.605 19.7883 10.4009C20.0064 9.96171 19.8272 9.42888 19.3881 9.21078L19.3608 9.19723C18.1938 8.61766 16.8402 8.54186 15.6158 8.98751L13.9535 9.59146L8.27736 7.52052ZM6 21.5H18C18.5523 21.5 19 21.9477 19 22.5C19 23.0523 18.5523 23.5 18 23.5H6C5.44772 23.5 5 23.0523 5 22.5C5 21.9477 5.44772 21.5 6 21.5Z" />
      </g>
      <defs>
        <clipPath id="clip0_78_133">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon;
